import { Component } from 'react';
import styles from './CancelAction.module.css';

export class CancelAction extends Component {
    handleClick = () => {
        const { onCancel, showQuestionHandler } = this.props;

        showQuestionHandler(false);

        if (onCancel) {
            onCancel();
        }
    };

    render() {
        const { children } = this.props;

        return (
            <button className={styles.CancelAction} onClick={this.handleClick}>
                {children}
            </button>
        );
    }
}
